
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/creator",
      function () {
        return require("private-next-pages/about/creator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/creator"])
      });
    }
  